'use client';

import { useState } from 'react';
import Link from 'next/link';

export default function CvButton() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link href="/register">
      <button
        type="button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`group relative inline-flex w-full max-w-[300px] items-center gap-2 overflow-hidden rounded-none border-2  border-[#D70C18] bg-[#D70C18] px-[10px] py-[13px] text-base font-semibold text-white transition-all duration-500 ease-in-out hover:text-[#D70C18] md:max-w-[380px] ${
          isHovered
            ? 'before:origin-left before:scale-x-100'
            : 'before:origin-left before:scale-x-0'
        } before:absolute before:inset-0 before:z-0 before:bg-white before:transition-transform before:duration-500`}
      >
        <span className="relative z-10 flex w-full items-center justify-between">
          <div className="w-[28px]"></div>
          <div className="flex items-center gap-2">
            <svg
              viewBox="0 0 19 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-[23px] w-[19px]"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0255 3.48215C9.11904 3.06046 8.11955 2.84961 7.02703 2.84961C5.06451 2.84961 3.40252 3.52997 2.04108 4.89069C0.679641 6.25141 -0.000719578 7.91339 5.71093e-07 9.87664C0.000721864 11.8399 0.681082 13.5019 2.04108 14.8626C3.40108 16.2233 5.06306 16.9037 7.02703 16.9037C7.81982 16.9037 8.56757 16.7775 9.27027 16.5253C9.97297 16.273 10.5946 15.9307 11.1351 15.4983L17.1892 21.5523C17.3874 21.7505 17.6396 21.8496 17.9459 21.8496C18.2523 21.8496 18.5045 21.7505 18.7027 21.5523C18.9009 21.3541 19 21.1019 19 20.7956C19 20.4892 18.9009 20.237 18.7027 20.0388L12.6486 13.9847C13.0811 13.4442 13.4234 12.8226 13.6757 12.1199C13.9279 11.4172 14.054 10.6695 14.0541 9.87672H11.8919C11.8926 11.2288 11.4198 12.3776 10.4735 13.3231C9.52721 14.2687 8.37838 14.7415 7.02703 14.7415C5.67856 14.7444 4.53009 14.2716 3.58162 13.3231C2.63315 12.3747 2.16 11.2258 2.16216 9.87664C2.16433 8.52745 2.63748 7.37898 3.58162 6.43123C4.52577 5.48348 5.67423 5.01033 7.02703 5.01177C7.86825 5.01267 8.63061 5.19597 9.31409 5.56168L10.0255 3.48215Z"
                fill="currentColor"
              />
              <path
                d="M11.0543 8H10.0167L12.0249 2.22662H12.9453L14.9534 8H13.9242L13.531 6.80349H11.4475L11.0543 8ZM12.4851 3.63231L11.7153 5.96677H13.2548L12.4851 3.63231ZM16.6664 2.22662V8H15.6958V2.22662H16.6664Z"
                fill="currentColor"
              />
            </svg>
            <span>無料でAIキャリア診断</span>
          </div>
          <svg
            viewBox="0 0 28 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-[24px] w-[28px]"
          >
            <path
              d="M18.5 7L24.5 13H2"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </svg>
        </span>
      </button>
    </Link>
  );
}
